/* eslint-disable react/jsx-pascal-case */

import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import React, { useState, Suspense, lazy, useEffect } from "react";
import 'react-slideshow-image/dist/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import { useCustomer } from '../../customers/useCustomer';
import { getpaymenttype } from '../../Helper/links';
import API from '../../Helper/server/API';
import { BookingProvider } from '../BookingContext';
import BookingServiceSelectedStep from './BookingServiceStep';
import BookingServiceConfirmStep from './BookingConfirmStep';
import BookingServiceStep from "./BookingCustomerStep";
function BookingServices() {
    const customer = useCustomer();
    const [bookingServiceData, setbookingServiceData] = useState(null);
    const [bookingCustomerData, setbookingCustomerData] = useState(customer);

    const handleServiceData = (data) => {
        setbookingServiceData(data);
    };

    const handleCustomertData = (data) => {
        setbookingCustomerData(data)
    };

    const [loading_get_payment_type, set_loading_get_payment_type] = useState(true)
    const [payment_types, set_get_payment_types] = useState([])
    const [paymentmethod, set_paymentmethod] = useState(null);

    const GetPaymentType = async () => {
        set_loading_get_payment_type(true);
        const response = await API.get(`${getpaymenttype}?state=1`)
        if (response?.success === 1) {
            set_get_payment_types(response.data);
        }
        set_loading_get_payment_type(false);
    }

    useEffect(() => {
        GetPaymentType();
    }, [])
    return (
        <div className="page-wrapper" dir="rtl"   >
            <div className="content-wrapper">
                {/* <div className="page-heading">
                    <h1 className="page-title"> إنشــاء حجــوزات </h1>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a href="index.html"><i className="la la-home font-20"></i></a>
                        </li>
                    </ol>
                </div> */}
                <br></br>
                <div className="row">
                    <div className="col-md-12">
                        <div className="ibox">
                            <BookingProvider>
                                <Stepper style={{ flexBasis: '50rem', fontFamily: "Cairo" }} headerPosition="bottom" icon='pi pi-users'>

                                    <StepperPanel key="customer-step" header={<p>العميـــل</p>}>
                                        <BookingServiceStep onDataChange={handleCustomertData} bookingCustomerData={bookingCustomerData} />
                                    </StepperPanel>

                                    <StepperPanel key="apartment-step-1" activeIndex='var(--primary-color)' header={<p> الخدمــات اليـومية</p>} icon="pi pi-user" style={{ margin: "0", padding: "0", width: "100%" }} title='sd'>
                                        <BookingServiceSelectedStep onDataChange={handleServiceData} bookingServiceData={bookingServiceData} ></BookingServiceSelectedStep>
                                    </StepperPanel>


                                    <StepperPanel key="confirm-step" header={<p>الحجــــز</p>}>
                                        <BookingServiceConfirmStep
                                            bookingServiceData={bookingServiceData}
                                            setbookingServiceData={setbookingServiceData}
                                            bookingCustomerData={bookingCustomerData}
                                            setbookingCustomerData={setbookingCustomerData}
                                            payment_types={payment_types}
                                            set_get_payment_types={set_get_payment_types}
                                            loading_get_payment_type={loading_get_payment_type}
                                            paymentmethod={paymentmethod}
                                            set_paymentmethod={set_paymentmethod}
                                        />
                                    </StepperPanel>

                                </Stepper>
                            </BookingProvider>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BookingServices

